/**
 * Directiva para los checkboxes
 * @author jkudla
 */
angular.module('mapes')
  .directive('checkBoxes', function ($compile) {
    return {
      restrict: 'E',
      scope: {
        checkboxes: '='
      },
      templateUrl: "./components/checkbox.component.html",

      link: function (scope) {
        scope.toggleChildren = function (node) {
          if (node.subnodes && !!node.subnodes.length) {           
            angular.forEach(node.subnodes, function (child) {
              child.value = node.value;
              scope.toggleChildren(child);
            });
          }
        };

        scope.toggleAllState = function (node, element) {
          if (node.subnodes && !!node.subnodes.length) {
            const parent = $(element).closest('.new-cerca__item-container');
            const child = parent.find('.new-cerca__child');
            if (child.css("display") === "none" && node.value) {
              child.slideDown();
              parent.addClass('is-open');
              child.closest('.new-cerca__item-container').addClass('is-open');
            }
          }
        };

        scope.toggleState = function ($event, node) {
          if (node.subnodes && !!node.subnodes.length) {
            const parent = $($event.target).closest('.new-cerca__item-container');
            const child = parent.find('.new-cerca__child').first();
            if (child.css("display") === "none") {
              child.slideDown();
              parent.addClass('is-open');
            } else {
              child.slideUp();
              parent.removeClass('is-open');
            }
          }
        };

        // Watch child checkboxes and update parent state
        scope.$watch('checkboxes', function updateParents(newNodes) {
          angular.forEach(newNodes, function (node) {
            if (node.subnodes && !!node.subnodes.length) {
              scope.$watchCollection(() => node.subnodes.map(c => c.value), () => {
                const total = node.subnodes.length;
                const value = node.subnodes.filter(c => c.value).length;

                node.value = value === total;
                node.indeterminate = value > 0 && value < total;
              });
            }
          });
        }, true);
      }
    };
  })

  .directive('indeterminateCheckbox', function () {
    return {
      restrict: 'A',
      link: function (scope, element, attrs) {
        scope.$watch(attrs.indeterminateCheckbox + '.indeterminate', function (value) {
          element[0].indeterminate = !!value;
        });
      }
    };
  })
  
  .directive('myOnChange', function () {
    return {
      restrict: 'A',
      scope: {
        myOnChange: '&'
      },
      link: function (scope, element) {
        element.on('change', function () {
          scope.$apply(function () {
            scope.myOnChange({
              value: element.val(),
              element: element
            });
          });
        });
      }
    };
  })